<template>
  <v-row>
    <v-col md="8" offset-md="2" xl="6" offset-xl="3">
      <BaseBlock title="Paramétrage">
        <v-form v-model="valid" ref="form">
          <BaseAlert :error="error" />
          <v-row>
            <v-col cols="12" md="6">
              <v-menu
                v-model="showCalendarDebut"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                max-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="formatedDateOuverture"
                    label="Date ouverture campagne *"
                    prepend-icon="event"
                    readonly
                    clearable
                    v-on="on"
                    autofocus
                    :rules="dateRules"
                  ></v-text-field>
                </template>
                <v-date-picker
                  locale="fr-fr"
                  :min="minDateOuverture"
                  :max="maxDateFermeture"
                  v-model="parametrage.dateOuvertureDefaut"
                  @input="showCalendarDebut = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="6">
              <v-menu
                v-model="showCalendarFin"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                max-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="formatedDateFermeture"
                    label="Date fermeture campagne *"
                    prepend-icon="event"
                    readonly
                    clearable
                    v-on="on"
                    autofocus
                    :rules="dateRules"
                  ></v-text-field>
                </template>
                <v-date-picker
                  locale="fr-fr"
                  :min="minDateOuverture"
                  :max="maxDateFermeture"
                  v-model="parametrage.dateFermetureDefaut"
                  @input="showCalendarFin = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-menu
                v-model="showCalendarReins"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                max-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="formatedDateButtoirReins"
                    label="Date butoir de réinscription *"
                    hint="(vaut date limite de confirmation étudiant)"
                    persistent-hint
                    prepend-icon="event"
                    readonly
                    clearable
                    v-on="on"
                    autofocus
                    :rules="dateRules"
                  ></v-text-field>
                </template>
                <v-date-picker
                  locale="fr-fr"
                  v-model="parametrage.dateButtoirReinscription"
                  @input="showCalendarReins = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="parametrage.maxCandidatures"
                label="Nombre maximum de candidatures *"
                hint="(par étudiant)"
                persistent-hint
                type="number"
                min="1"
                prepend-icon="mdi-account"
                :rules="maxcandidatureRules"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-checkbox
                v-model="parametrage.campagnePrecoce"
                label="Campagne précoce"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6" offset="0" offset-md="3">
              <div class="text-center">
                <v-btn
                  class="mx-2"
                  :disabled="!valid"
                  color="primary"
                  @click="enregistrer"
                  :loading="loading"
                >
                  <v-icon left>save</v-icon>Enregistrer
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-form>
      </BaseBlock>
    </v-col>
  </v-row>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";
import BaseForm from "@/components/base/BaseForm";
import moment from "moment";
import ApiParametrageRepository from "@/repositories/ApiParametrageRepository";
import BaseAlert from "@/components/base/BaseAlert";

export default {
  name: "Parametrage",
  components: { BaseBlock, BaseAlert },
  extends: BaseForm,
  data() {
    return {
      showCalendarDebut: false,
      showCalendarFin: false,
      showCalendarReins: false,
      loading: false,
      parametrage: {
        dateOuvertureDefaut: "",
        dateFermetureDefaut: "",
        dateButtoirReinscription: "",
        campagnePrecoce: false,
      },
      dateRules: [(v) => !!v || "La date est requise"],
      maxcandidatureRules: [
        (v) => v > 0 || "La valeur est requise et doit être supérieure à 0",
      ],
      // date min ouverture dans l'année universitaire
      jrMinDate: "01",
      moisMinDate: "08", // 08 -> Septembre
      // date max ouverture dans l'année universitaire
      jrMaxDate: "31",
      moisMaxDate: "07", // 07 -> Août
    };
  },
  computed: {
    formatedDateOuverture: {
      get() {
        return this.parametrage.dateOuvertureDefaut
          ? moment(this.parametrage.dateOuvertureDefaut).format("DD/MM/YYYY")
          : "";
      },
      set(value) {
        this.parametrage.dateOuvertureDefaut = value;
      },
    },
    formatedDateFermeture: {
      get() {
        return this.parametrage.dateFermetureDefaut
          ? moment(this.parametrage.dateFermetureDefaut).format("DD/MM/YYYY")
          : "";
      },
      set(value) {
        this.parametrage.dateFermetureDefaut = value;
      },
    },
    formatedDateButtoirReins: {
      get() {
        return this.parametrage.dateButtoirReinscription
          ? moment(this.parametrage.dateButtoirReinscription).format(
              "DD/MM/YYYY"
            )
          : "";
      },
      set(value) {
        this.parametrage.dateButtoirReinscription = value;
      },
    },
    minDateOuverture() {
      return moment().format("MM") > 8
        ? moment([
            moment().format("YYYY"),
            this.moisMinDate,
            this.jrMinDate,
          ]).format("YYYY-MM-DD")
        : moment([
            moment().subtract(1, "years").format("YYYY"),
            this.moisMinDate,
            this.jrMinDate,
          ]).format("YYYY-MM-DD");
    },
    maxDateFermeture() {
      return moment().format("MM") > 8
        ? moment([
            moment().add(1, "years").format("YYYY"),
            this.moisMaxDate,
            this.jrMaxDate,
          ]).format("YYYY-MM-DD")
        : moment([
            moment().format("YYYY"),
            this.moisMaxDate,
            this.jrMaxDate,
          ]).format("YYYY-MM-DD");
    },
  },
  methods: {
    async enregistrer() {
      try {
        this.loading = true;
        const parametrage = await ApiParametrageRepository.setParametrage(
          this.parametrage
        );
        this.parametrage = parametrage;
        this.$toast.success("Les paramètres ont été enregistrés");
        this.error.messages = undefined;
      } catch (error) {
        this.populateErrors(error);
      } finally {
        this.loading = false;
      }
    },
    async getParametrage() {
      try {
        const parametrage = await ApiParametrageRepository.getParametrage(
          this.parametrage
        );
        if (parametrage) {
          this.parametrage = parametrage;
        }
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      }
    },
  },
  created() {
    this.getParametrage();
  },
};
</script>
